import React from 'react';
import { Section, SectionHeader } from './ui/Section';
import { Reveal } from './ui/Reveal';
import { BookOpen, Award } from 'lucide-react';
export function EducationSection() {
  return <Section id="education" variant="charcoal" data-id="element-162">
      <SectionHeader title="Credentials" subtitle="Education & Training" data-id="element-163" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-164">
        <Reveal data-id="element-165">
          <div className="space-y-6" data-id="element-166">
            <h3 className="text-2xl text-white font-heading uppercase border-b border-gold-500/30 pb-2 mb-6" data-id="element-167">
              Academic Degrees
            </h3>
            {[{
            degree: 'M.S. National Resource Strategy',
            school: 'National Defense University'
          }, {
            degree: 'M.S. Materiel Acquisition Management',
            school: 'Florida Institute of Technology'
          }, {
            degree: 'B.S. Business Administration',
            school: 'Emporia State University'
          }].map((edu, i) => <div key={i} className="flex gap-4" data-id="element-168">
                <div className="mt-1" data-id="element-169">
                  <BookOpen className="w-5 h-5 text-gold-500" data-id="element-170" />
                </div>
                <div data-id="element-171">
                  <h4 className="text-lg font-bold text-white" data-id="element-172">{edu.degree}</h4>
                  <p className="text-slate-400" data-id="element-173">{edu.school}</p>
                </div>
              </div>)}
          </div>
        </Reveal>

        <Reveal delay={200} data-id="element-174">
          <div className="space-y-6" data-id="element-175">
            <h3 className="text-2xl text-white font-heading uppercase border-b border-gold-500/30 pb-2 mb-6" data-id="element-176">
              Certifications
            </h3>
            <ul className="space-y-4" data-id="element-177">
              {['DAWIA Level III Certification', 'Joint Professional Military Education Phase II', 'Life Cycle Logistics, Level III — Defense Acquisition Workforce Improvement Act (DAWIA)'].map((cert, i) => <li key={i} className="flex items-center bg-navy-900 p-4 border-l-2 border-gold-500" data-id="element-178">
                  <Award className="w-5 h-5 text-gold-500 mr-3" data-id="element-179" />
                  <span className="text-slate-300 font-medium" data-id="element-180">{cert}</span>
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>
    </Section>;
}